import { useCallback } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { PopUpMobile } from '@bwoty-web/styleguide';

import styles from './TripLengthFieldOverlay.scss';

export const TripLengthFieldOverlay = ({
  isOpen = false,
  header,
  title,
  tripLengths,
  selected,
  onClose,
  onClick,
}) => {
  const handleOnClick = useCallback(
    (item) => {
      onClick(item);
      onClose();
    },
    [tripLengths],
  );

  return (
    <PopUpMobile closed={!isOpen} close={onClose} header={header} className={styles.root}>
      <div className={styles.body}>
        <div className={styles.title}>{title}</div>
        {tripLengths.map((item) => {
          return (
            <button
              key={item.value}
              type="button"
              className={classNames(styles.button, {
                [styles.selected]: selected && selected.value === item.value,
              })}
              data-test={`lms-triplength-opt-${item.value}`}
              onClick={() => handleOnClick(item)}
            >
              {item.displayName}
            </button>
          );
        })}
      </div>
    </PopUpMobile>
  );
};

const tripLengthItemShape = PropTypes.shape({
  value: PropTypes.number,
  displayName: PropTypes.string,
});

TripLengthFieldOverlay.propTypes = {
  isOpen: PropTypes.bool,
  title: PropTypes.node,
  header: PropTypes.node,
  onClick: PropTypes.func,
  onClose: PropTypes.func.isRequired,
  selected: tripLengthItemShape,
  tripLengths: PropTypes.arrayOf(tripLengthItemShape),
};
